exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board-cart-title span[data-v-0af61188]{color:#16181f;font-size:14px;font-weight:500;font-family:Fira Sans,sans-serif;padding:7px 13px;display:block;height:100%}", ""]);

// exports
